import React, {Component} from 'react';
import {Table, Badge,	Pagination as RStrapPagination, PaginationItem, PaginationLink} from 'reactstrap';
import PropTypes from 'prop-types';

 class Pagination extends Component {
	
	render() {
		const {page, pages} = this.props;

		if (pages <= 1) {
			return null;
		}

		return (
			<RStrapPagination style={{justifyContent: 'flex-end', marginTop: '20px', marginBottom: '0px'}}>
				<PaginationItem disabled={page == 1}>
					<PaginationLink previous onClick={() => this.props.onChangePage(page-1)}></PaginationLink>
				</PaginationItem>
					{	Array.apply(1, Array(pages)).map((x, i) => (
							<PaginationItem key={`pagination-${i+1}`} active={page == i+1}>
								<PaginationLink onClick={() => this.props.onChangePage(i+1)}>{i+1}</PaginationLink>
							</PaginationItem>)
						)
					}
				<PaginationItem disabled={page >= pages}>
					<PaginationLink next onClick={() => this.props.onChangePage(page+1)}></PaginationLink>
				</PaginationItem>
			</RStrapPagination>
		)
	}
}

export default Pagination;